export default "__VITE_ASSET__BqMR7QI1__"